import { ToastrService } from 'ngx-toastr';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { BsDatepickerConfig, BsDaterangepickerDirective } from 'ngx-bootstrap/datepicker';
import { Router } from '@angular/router';
import { Component, Inject, ViewChild } from '@angular/core';
import { ViewContainerRef, Input, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import * as locales from 'ngx-bootstrap/locale';
import { MatDatepicker } from '@angular/material/datepicker';
import { OfferlistService } from 'modules/shared/legacy-bookexpress/services/OfferList.service';
import { PreloaderService } from 'modules/shared/legacy-bookexpress/services/preloader.service';
import { SharedService } from 'modules/shared/legacy-bookexpress/services/shared.service';
import { BookService } from 'modules/shared/legacy-bookexpress/services/book.service';
import { MaintenanceService } from 'modules/shared/legacy-bookexpress/services/maintenance.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DateFunctionConfig } from 'app/model/shared/backend-api-response/date-function-config';
import { RGuestMessages } from 'app/model/shared/backend-api-response/rguest-messages';
import { Permissions } from 'app/model/shared/backend-api-response/permissions';
import { GetOfferApiResponse } from 'app/model/wbe/backend-api-response/get-offer-api-response';
import { GoogleAnalyticsEventsService } from 'modules/shared/legacy-bookexpress/services/google-analytics-events.service';
import { CryptoconvertService } from 'modules/shared/legacy-bookexpress/services/cryptoconvert.service';

@Component({
  selector: 'app-search-pop',
  templateUrl: './search-pop.component.html',
  styleUrls: ['./search-pop.component.scss', './search-pop-style-handler.component.scss'],
})
export class SearchPopComponent {
  @Input() currencyValue: Node;
  ArrDepDate: Array<any> = [];
  minDate: Date;
  tenantId: any;
  preload: boolean = false;
  propertyId: any;
  guestCount: any;
  rGuestBookMessages: RGuestMessages;
  colorTheme = 'theme-dark-blue ';
  casinoNumber: string;
  arrDate: string;
  maxNightsAllowed: any;
  depDate: string;
  bsConfig: Partial<BsDatepickerConfig>;
  public offerCode: string;
  public localeData: any;
  public countryCode: string;
  rGuestBookPermissions: Permissions;
  enableBook: boolean = false;
  selectedOffer: any;
  authorClick: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  checkinBlockDays: Array<any> = [];
  offerError: string;
  @ViewChild('arrPicker')
  private arrDatePicker: MatDatepicker<Date>;
  @ViewChild('depPicker')
  private depDatePicker: MatDatepicker<Date>;
  public isIE11 = !!(window as any).MSInputMethodContext && !!(document as any).documentMode;
  public IEarrival: any;
  public IEdeparture: any;
  dateFunctionConfig: DateFunctionConfig;

  constructor(
    private router: Router,
    private _offerList: OfferlistService,
    public toastr: ToastrService,
    public CommonService: LegacyBookInitService,
    public PreloaderService: PreloaderService,
    public cryptoConvert: CryptoconvertService,
    private _shared: SharedService,
    vcr1: ViewContainerRef,
    private BookService: BookService,
    public MaintenanceService: MaintenanceService,
    public ConfigService: LegacyBookInitService,
    private localeService: BsLocaleService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SearchPopComponent>,
    private googleAnalytics: GoogleAnalyticsEventsService
  ) {
    this.offerCode = data.offerDetails;
    this.selectedOffer = data.selectedOffer;
    this.casinoNumber = data.casinoNumber;
    this.checkinBlockDays = data.checkinBlockDays;
    this.localeData = this.ConfigService?.localeData;
    this.countryCode = this.ConfigService?.PropertyData?.countryCode;
    // for (const locale in this.localeData) {
    //   if(this.countryCode.toLowerCase() === this.localeData[locale].abbr)
    //   {
    //    this.localeService.use(this.countryCode);
    //   }
    // }
    this.dateFunctionConfig = this.CommonService?.PropertyData?.dateFunctionConfig;
    for (const locale in locales) {
      if (this.dateFunctionConfig.dateRangePickerFormat === locales[locale].abbr) {
        this.localeService.use(this.dateFunctionConfig.dateRangePickerFormat);
      }
    }
    this.tenantId = this.ConfigService?.gettenantId();
    this.propertyId = this.ConfigService?.getpropertyId();
    this.guestCount = this.ConfigService?.getguest_count();
    this.rGuestBookMessages = this.ConfigService?.PropertyData?.rGuestMessages;
    this.rGuestBookPermissions = this.ConfigService?.PropertyData?.permissions;
    //  this.toastr.setRootViewContainerRef(vcr1);
    const dateFormat = moment.localeData(this.dateFunctionConfig?.locale).longDateFormat('L');
    this.bsConfig = Object.assign({
      containerClass: this.colorTheme,
      displayMonths: 1,
      showWeekNumbers: false,
      rangeInputFormat: dateFormat,
      rangeSeparator: ' - ',
    });
  }

  ngOnInit() {
    setTimeout(() => {
      $('#gotores').removeClass('active');
    }, 500);
    this.processConfig(this.CommonService?.configDetailsData);

    this.googleAnalytics.eventEmitter('search_pop_up_screen', 'booking', 'loaded_search_pop_up_screen', 'search_pop_up_component');
  }

  @ViewChild('dpr')
  private _picker: BsDaterangepickerDirective;

  onShowPicker(event) {
    const dayHoverHandler = event.dayHoverHandler;
    let arrivalDate, departureDate;
    const hoverWrapper = (hoverEvent) => {
      const { cell, isHovered } = hoverEvent;

      if (isHovered && !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) && 'ontouchstart' in window) {
        if (!arrivalDate) arrivalDate = cell.date;
        else {
          if (moment(cell.date).isAfter(moment(arrivalDate))) {
            departureDate = cell.date;
            setTimeout(() => {
              (this._picker as any)._datepickerRef.instance.daySelectHandler(cell);
            }, 100);
          } else {
            arrivalDate = cell.date;
          }
        }
      } else {
        return dayHoverHandler(hoverEvent);
      }
      if (arrivalDate && departureDate) return dayHoverHandler(hoverEvent);
    };
    event.dayHoverHandler = hoverWrapper;
  }

  close() {
    let pathData = location.pathname.split('/');
    let comp;
    if (pathData[2] == 'cico' || pathData[2] == 'wbe') {
      comp = pathData[3];
    } else {
      comp = pathData[2];
    }
    if (comp == 'calendar') {
      this.router.navigate(['/wbe/offers/' + this.tenantId + '/' + this.propertyId]);
    }
  }

  processConfig(data) {
    if (data == null || !data.Success) {
      data.service = 'Propery Config service';
      this.PreloaderService.sendData({ value: 'No preload', status: false });
      this.MaintenanceService.putMaintenanceData(data);
      this.router.navigate(['/wbe/maintenance/' + this.tenantId + '/' + this.propertyId]);
    } else {
      this.maxNightsAllowed = data.maxNightsAllowed;
      let localDate = data.currentHotelDate;
      let yyyy = data.currentHotelDate.slice(0, 4);
      let mm = data.currentHotelDate.slice(5, 7);
      if (mm > 0) mm = mm - 1;
      let dd = data.currentHotelDate.slice(8, 10);
      this.minDate = new Date(yyyy, mm, dd);
    }
  }
  validatedates(selectedDate) {
    if (Array.isArray(selectedDate)) {
      if (selectedDate.length > 0) {
        let ArrivalDate: Date = selectedDate[0];
        let DepartureDate: Date = selectedDate[1];
        ArrivalDate = new Date(ArrivalDate);
        let ArrDate = this.getDate(ArrivalDate);
        DepartureDate = new Date(DepartureDate);
        let DepDate = this.getDate(DepartureDate);
        let outArrivalDate = ArrDate;
        let outDepartureDate = ArrDate;
        var timeDiff = Math.abs(ArrivalDate.getTime() - DepartureDate.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        if (this.maxNightsAllowed != 0 && diffDays > this.maxNightsAllowed) {
          this.ArrDepDate = [];
          let errordate = 'Selected date range exceeds the maximum stay limit of ' + this.maxNightsAllowed + ' day(s)';
          this.toastr.error(errordate);
        } else {
          this.enableBook = true;
        }
      }
    }
  }
  getDate(UnformattedDate: Date) {
    let mm, dd, yyyy;
    mm = UnformattedDate.getMonth() + 1;
    mm = this.checkFormat(mm);
    dd = UnformattedDate.getDate();
    dd = this.checkFormat(dd);
    yyyy = UnformattedDate.getFullYear();
    return yyyy + '-' + mm + '-' + dd;
  }
  checkFormat(i) {
    if (i < 10) {
      i = '0' + i;
    }
    return i;
  }

  validateandmove() {
    this.authorClick.emit(true);
    this.preload = true;
    // let data = {
    //   status: true,
    //   value: "Validating Arrival and Departure date. Please wait..."
    // }
    // this.PreloaderService.sendData(data);
    if (Array.isArray(this.ArrDepDate)) {
      if (this.ArrDepDate.length > 0) {
        let ArrivalDate: Date = this.ArrDepDate[0];
        let DepartureDate: Date = this.ArrDepDate[1];
        ArrivalDate = new Date(ArrivalDate);
        let ArrDate = this.getDate(ArrivalDate);
        this.arrDate = ArrDate;
        DepartureDate = new Date(DepartureDate);
        let DepDate = this.getDate(DepartureDate);
        this.depDate = DepDate;
        let arrDate = this.arrDate.split('-');
        let depDate = this.depDate.split('-');
        this.IEarrival = new Date(+arrDate[0], +arrDate[1] - 1, +arrDate[2]);
        this.IEdeparture = new Date(+depDate[0], +depDate[1] - 1, +depDate[2]);
        var outArrivalDate = ArrDate;
        var outDepartureDate = DepDate;
        var outCasinoNumber = '';
        if (this.selectedOffer.casinoNumberRequired == true) {
          outCasinoNumber = this.casinoNumber;
        } else {
          outCasinoNumber = '';
        }
        this._offerList
          .getsingleOffers(
            '',
            '',
            '',
            outArrivalDate,
            outDepartureDate,
            this.offerCode,
            outCasinoNumber,
            this.selectedOffer.casinoNumberRequired
          )
          .subscribe(
            (result: GetOfferApiResponse) => {
              this.processOffer(result);
              this.preload = false;
              // this.PreloaderService.sendData({ value: "No preload", status: false })
            },
            (error) => {
              this.toastr.error(this._offerList.errorMessage);
              this.preload = false;
              // this.PreloaderService.sendData({ value: "No preload", status: false })
            }
          );
      }
    }
  }

  processOffer = (offer) => {
    if (offer.Success == true) {
      if (offer.offers.length > 0) {
        if (offer.offers[0].isOfferValid) {
          sessionStorage.setItem('casinoNumber', this.casinoNumber);
          this.BookService.changeOffer(offer.offers[0].offerDescription);
          let offerCodeData;
          if (this.rGuestBookPermissions.functionalPermissions.encryptOfferCodeinURL)
            offerCodeData = this.cryptoConvert.convertOfferCode(this.offerCode, 'encrypt');
          else offerCodeData = this.offerCode;
          this.dialogRef.close();

          this.googleAnalytics.eventEmitter(
            'showRoom_button',
            'room',
            'navigated_to_wbe/room_page',
            `tenantId- ${this.tenantId}, offerCode -${this.offerCode}, arrival/Departure Date - ${this.IEarrival}/${this.IEdeparture}`
          );
          this.router.navigate([
            'wbe/room',
            this.tenantId,
            this.propertyId,
            this.arrDate,
            this.depDate,
            offerCodeData,
            this.guestCount || 2,
          ]);
        } else {
          this.toastr.warning(offer.offers[0].offerNotValidReason);
          this.offerError = offer.offers[0].offerNotValidReason;
        }
      } else {
        this.offerError = 'Offer ' + this.offerCode + ' not available on selected dates.';
        this.toastr.warning('Offer not available on selected dates.');
      }
    } else {
      this.toastr.warning(offer.ErrorMessage);
    }
  };
  ngOnDestroy() {
    this.ArrDepDate = [];
  }

  validateArrDate(arrDate) {
    let arrDate1;
    let depDate1;
    arrDate1 = moment(arrDate).format('YYYY-MM-DD');
    depDate1 = this.depDate ? moment(this.depDate).format('YYYY-MM-DD') : '';
    let arr = arrDate1.split('-');
    let dep = depDate1 ? depDate1.split('-') : '';
    this.ArrDepDate = [new Date(+arr[0], +arr[1] - 1, +arr[2]), dep ? new Date(+dep[0], +dep[1] - 1, +dep[2]) : ''];
    this.arrDate = arrDate1;
    this.depDate = depDate1;
    this.IEarrival = new Date(+arr[0], +arr[1] - 1, +arr[2]);
    this.IEdeparture = dep ? new Date(+dep[0], +dep[1] - 1, +dep[2]) : '';
    setTimeout(() => {
      this.depDatePicker.open();
    }, 500);
    if (this.arrDate && this.depDate) {
      this.enableBook = true;
    } else {
      this.enableBook = false;
    }
  }
  validateDepDate(depDate) {
    let arrDate2;
    let depDate2;
    arrDate2 = this.arrDate ? moment(this.arrDate).format('YYYY-MM-DD') : '';
    depDate2 = moment(depDate).format('YYYY-MM-DD');
    let arr = arrDate2 ? arrDate2.split('-') : '';
    let dep = depDate2.split('-');
    this.ArrDepDate = [arr ? new Date(+arr[0], +arr[1] - 1, +arr[2]) : '', new Date(+dep[0], +dep[1] - 1, +dep[2])];
    this.depDate = depDate2;
    this.arrDate = arrDate2;
    this.IEarrival = arr ? new Date(+arr[0], +arr[1] - 1, +arr[2]) : '';
    this.IEdeparture = new Date(+dep[0], +dep[1] - 1, +dep[2]);
    if (this.arrDate && this.depDate) {
      this.enableBook = true;
    } else {
      this.enableBook = false;
    }
  }
}
